import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login"
import Home from '../views/Home.vue'
import store from '../store'
import axios from '../axios'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		children: [
			{
				path: '/index',
				name: 'Index',
				meta: {
					title: "首页"
				},
				component: () => import('@/views/Index.vue')
			},
			{
				path: '/userCenter',
				name: 'UserCenter',
				meta: {
					title: "个人中心"
				},
				component: () => import('@/views/UserCenter.vue')
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},

]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {

	let hasRoute = store.state.menus.hasRoute
	let menus = store.state.menus.menuList

	let token = localStorage.getItem("token")

	if (to.path == '/login') {

		console.log("login!!!!!!!!!!!")
		next()

	} else if (!token) {
		next({path: "/login"})

	} else if (token && !hasRoute) {
		let newRoutes = router.options.routes;

		axios.get("/sys/menu/nav").then(res => {

			console.log(res.data.data)
			store.commit("setMenuList", res.data.data.nav)
			store.commit("setPermList", res.data.data.authoritys)

			console.log(res.data.data.authoritys.toString())

			res.data.data.nav.forEach(menu => {
				if (menu.children) {
					menu.children.forEach(e => {

						let route = menuToRoute(e)
						if (route) {
							newRoutes[0].children.push(route)
						}
					})
				}
			})

			console.log("oldRoutes---------------")
			console.log(newRoutes)

			router.addRoutes(newRoutes)
			hasRoute = true
			store.commit("changeRouteStatus", hasRoute)

			next({path: to.path})
		})

	} else {
		next()

	}
})

const menuToRoute = (menu) => {

	console.log("正在添加menu--》")
	console.log(menu)

	if (!menu.component) {
		return null
	}
	// 复制属性
	let route = {
		name: menu.name,
		path: menu.path,
		meta: {
			icon: menu.icon,
			title: menu.title
		}
	}

	route.component = () => import('@/views/' + menu.component + '.vue')

	return route
}


export default router
